// Pembantu pautan WhatsApp click-to-chat (wa.me).
// Bendahara klik butang -> WhatsApp terbuka dengan mesej sedia terisi -> hantar manual.
// Tiada API/gateway: percuma, tiada setup, nombor kekal di tangan bendahara.

// Normalisasi ke format antarabangsa tanpa '+'. Nombor Malaysia '01x...' -> '601x...'.
export function waDigits(phone) {
  let d = String(phone || '').replace(/\D/g, '');
  if (!d) return '';
  if (d.startsWith('0')) d = '60' + d.slice(1);
  return d;
}

// Pulangkan URL wa.me lengkap, atau null jika tiada nombor.
export function waLink(phone, text) {
  const d = waDigits(phone);
  if (!d) return null;
  return `https://wa.me/${d}${text ? `?text=${encodeURIComponent(text)}` : ''}`;
}
